import $apiJSON from 'http/apiJSON'

const BASE = '/students'

export const getStudent = (id) => $apiJSON.get(`${BASE}/${id}/`)
export const academicLeave = (id, payload) =>
  $apiJSON.post(`${BASE}/${id}/academic-leave/`, payload, { responseType: 'blob' })
export const expelStudent = (id, payload) =>
  $apiJSON.post(`${BASE}/${id}/expel/`, payload, { responseType: 'blob' })
export const graduateStudent = (id, payload) =>
  $apiJSON.post(`${BASE}/${id}/graduate/`, payload, { responseType: 'blob' })
export const restoreStudent = (id, payload) =>
  $apiJSON.post(`${BASE}/${id}/restore/`, payload, { responseType: 'blob' })

export default {
  getStudent,
  academicLeave,
  expelStudent,
  graduateStudent,
  restoreStudent,
}
